"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonAsLink = exports.Link = exports.Anchor = exports.linkStyle = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const linkStyle = ({ disabled, size = 'sm' }, ...extraStyles) => {
    let sizeClasses;
    switch (size) {
        case 'lg':
            sizeClasses = 'text-lg';
            break;
        case 'xs':
            sizeClasses = 'text-xs';
            break;
        case 'sm':
            sizeClasses = 'text-sm';
            break;
        default:
            sizeClasses = 'text-base';
            break;
    }
    const textStyles = disabled ? 'text-blue-5 opacity-60' : 'text-blue-5 hover:text-blue-6 cursor-pointer';
    return (0, classnames_1.default)(sizeClasses, textStyles, ...extraStyles);
};
exports.linkStyle = linkStyle;
const Anchor = ({ children, href, target, onClick, disabled, className, tracking, ...base }) => {
    const linkStyleProps = { ...base, disabled };
    return (react_1.default.createElement("a", { href: href, className: (0, exports.linkStyle)(linkStyleProps, className, tracking), target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, onClick: onClick }, children));
};
exports.Anchor = Anchor;
const Link = ({ children, to, onClick, disabled, className, tracking, ...base }) => {
    const linkStyleProps = { ...base, disabled };
    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: (0, exports.linkStyle)(linkStyleProps, className, tracking), onClick: onClick }, children));
};
exports.Link = Link;
const ButtonAsLink = ({ children, onClick, disabled, className, tracking, ...base }) => {
    const linkStyleProps = { ...base, disabled };
    return (react_1.default.createElement("button", { type: "button", onClick: onClick, role: "link", disabled: disabled, className: (0, exports.linkStyle)(linkStyleProps, 'disabled:opacity-60', className, tracking) }, children));
};
exports.ButtonAsLink = ButtonAsLink;
